'use strict';

var cssConstants = require('../utils/cssConstants');

var selectors = {
    form: '.js-newsletter-form',
    reCaptchaTokenFieldNLSub: '.js-gCaptchaToken-nlsub',
    csrfField: '.js-newsletter-csrf',
    messageContainerSuccess: '.js-newsletter-message',
    messageContainerError: '.js-newsletter-invalid-feedback',
    mainContainer: '.js-newsletter-main',
    emailField: '.js-newsletter-email',
    optinField: '.js-newsletter-optin'
};

/**
 * Picks the text to display for a server answer. Rewritten messages travel on the form itself: the subscription
 * route cannot know which component instance a submission came from, so it answers a code and a default text.
 * @param {Object} $form - The newsletter form jQuery object.
 * @param {Object} payload - JSON answer, holding a code and a message.
 * @returns {string} The message to display, empty when there is none.
 */
function resolveMessage($form, payload) {
    var messages = $form.data('messages') || {};

    return (payload.code && messages[payload.code]) || payload.message || '';
}

/**
 * Clears the answer of the previous attempt, which would otherwise sit next to the new one.
 * @param {Object} $form - The newsletter form jQuery object.
 * @returns {void}
 */
function clearFeedback($form) {
    $form.find(selectors.emailField).removeClass(cssConstants.INVALID);
    $form.find(selectors.messageContainerError).text('');
    $form.find(selectors.messageContainerSuccess).addClass(cssConstants.HIDDEN).text('');
}

/**
 * Displays a message next to the e-mail field. Every lookup is scoped to the submitted form, since the home page
 * may hold several instances of the component.
 * @param {Object} $form - The newsletter form jQuery object.
 * @param {string} message - Text to display, already resolved.
 * @param {boolean} isError - Whether the answer is a failure.
 * @returns {void}
 */
function showFeedback($form, message, isError) {
    if (!message) {
        return;
    }

    if (isError) {
        $form.find(selectors.emailField).addClass(cssConstants.INVALID);
        $form.find(selectors.messageContainerError).text(message);
        return;
    }

    $form.find(selectors.messageContainerSuccess).removeClass(cssConstants.HIDDEN).text(message);
}

/**
 * Submits the newsletter form to back-end.
 * @param {*} $form jQuery object
 */
function submitNewsletterForm($form) {
    clearFeedback($form);

    // The token comes from a remote include, which the platform replaces with an empty string when it fails,
    // leaving a complete looking form in a page that stays cached. Posting would log the shopper out every try.
    if (!$form.find(selectors.csrfField).length) {
        $form.spinner().stop();
        showFeedback($form, $form.data('fallback-message'), true);
        return;
    }

    $.ajax({
        url: $form.attr('action'),
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
            $form.spinner().stop();

            if (!data.success) {
                showFeedback($form, resolveMessage($form, data), true);
                return;
            }

            var $main = $form.closest(selectors.mainContainer);
            if ($main.length > 0) {
                // The unsubscription page answers in place of its whole section. Set as text, never as markup,
                // since a contributor may have rewritten the message.
                $main.empty().append($('<p></p>').text(resolveMessage($form, data)));
                return;
            }

            showFeedback($form, resolveMessage($form, data), false);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'alert.creation',
                click: 'Créer votre alerte'
            });
        },
        error: function (err) {
            $form.spinner().stop();

            var payload = (err && err.responseJSON) || {};

            // A rejected CSRF token answers json holding a redirect and no message, and the platform has already
            // logged the shopper out: following it is the only way they learn anything happened.
            if (payload.redirectUrl) {
                window.location.href = payload.redirectUrl;
                return;
            }

            // A timeout or a gateway error answers html, so there is no message to resolve and the form prints
            // the one it carries rather than leaving the shopper before an unchanged page.
            showFeedback($form, resolveMessage($form, payload) || $form.data('fallback-message'), true);
        }
    });
}

/**
 * Guides the shopper to the field that blocks the subscription, now that the submit button stays clickable. The
 * browser rejects the field on its own constraints and clientSideValidation paints the invalid state; this adds
 * the shake, plus the focus and the reset on the opt-in checkbox.
 * @param {Object} $form - The newsletter form jQuery object.
 * @returns {void}
 */
function bindFieldErrors($form) {
    $form.find('input').on('invalid', function () {
        // The class is dropped on animation end so the shake replays on the next attempt.
        var $formGroup = $(this).closest('.form-group');

        $formGroup
            .off('animationend.newsletterShake')
            .addClass(cssConstants.SHAKE)
            .one('animationend.newsletterShake', function () {
                $formGroup.removeClass(cssConstants.SHAKE);
            });
    });

    var $optin = $form.find(selectors.optinField);
    if (!$optin.length) {
        return;
    }

    var $optinGroup = $optin.closest('.form-group');
    var emailField = $form.find(selectors.emailField).get(0);

    $optin.on('invalid', function () {
        // The e-mail field comes first in the DOM, so it keeps the focus when it is invalid too.
        if (!emailField || emailField.validity.valid) {
            this.focus();
        }
    });

    $optin.on('change', function () {
        $optin.removeClass(cssConstants.INVALID);
        $optinGroup.removeClass(cssConstants.FORM_GROUP_INVALID + ' ' + cssConstants.SHAKE);
    });
}

module.exports = {
    newsletterSubscribe: function () {
        $(selectors.form).each(function () {
            var $form = $(this);

            bindFieldErrors($form);

            $form.on('submit', function (e) {
                e.preventDefault();
                $form.spinner().start();

                // The site key travels on the token field, which the form prints only when reCaptcha is on.
                var $captchaField = $form.find(selectors.reCaptchaTokenFieldNLSub);
                var gsiteKey = $captchaField.data('gsite-key');

                if (!window.grecaptcha || !gsiteKey) {
                    submitNewsletterForm($form);
                    return;
                }

                window.grecaptcha.ready(function () {
                    window.grecaptcha
                        .execute(gsiteKey, { action: $form.data('action') })
                        .then(function (token) {
                            $captchaField.val(token);
                            submitNewsletterForm($form);
                        });
                });
            });
        });
    }
};
